const COVERAGE = { new: 250, old: 150 };

const SIZE_5 = 5;
const SIZE_1 = 1;
const SIZE_Q = 0.25;
const ALLOWED_QUARTS = [0, 1];

const TONES = window.SunFrogTones || [];
const CATALOG = window.SunFrogCalcCatalog || {};

function catalogStainImage() {
  return CATALOG.stain?.image || "";
}

const PRODUCTS = {
  "5gal": {
    id: "stain-5gal",
    sizeKey: "5gal",
    name: CATALOG.stain?.name || "Sun Frog Stain & Sealer",
    size: CATALOG.stain?.sizes?.["5gal"]?.label || "5 Gallon",
    gallons: 5,
    image: catalogStainImage(),
    requiresTone: true,
  },
  "1gal": {
    id: "stain-1gal",
    sizeKey: "1gal",
    name: CATALOG.stain?.name || "Sun Frog Stain & Sealer",
    size: CATALOG.stain?.sizes?.["1gal"]?.label || "1 Gallon",
    gallons: 1,
    image: catalogStainImage(),
    requiresTone: true,
  },
  quart: {
    id: "stain-quart",
    sizeKey: "quart",
    name: CATALOG.stain?.name || "Sun Frog Stain & Sealer",
    size: CATALOG.stain?.sizes?.quart?.label || "1 Quart",
    gallons: 0.25,
    image: catalogStainImage(),
    requiresTone: true,
  },
};

const PREP_PRODUCTS = {
  cleaner: {
    id: "wood-cleaner",
    name: CATALOG.cleaner?.name || "Sun Frog Wood Cleaner",
    size: CATALOG.cleaner?.size || "1 Gallon",
    image: CATALOG.cleaner?.image || "",
    variantId: CATALOG.cleaner?.variantId || null,
    requiresTone: false,
  },
  brightener: {
    id: "wood-brightener",
    name: CATALOG.brightener?.name || "Sun Frog Wood Brightener",
    size: CATALOG.brightener?.size || "1 Gallon",
    image: CATALOG.brightener?.image || "",
    variantId: CATALOG.brightener?.variantId || null,
    requiresTone: false,
  },
};

function fmt(n) {
  return (Math.round(n * 100) / 100).toFixed(2);
}

function calculateOrder(squareFeet, woodType) {
  const coveragePerGallon = COVERAGE[woodType];
  if (!coveragePerGallon || !squareFeet || squareFeet <= 0) {
    return null;
  }

  const gallonsNeeded = squareFeet / coveragePerGallon;
  const max5 = Math.ceil(gallonsNeeded / SIZE_5) + 2;
  const max1 = Math.ceil(gallonsNeeded / SIZE_1) + 4;

  let best = null;

  for (let n5 = 0; n5 <= max5; n5++) {
    for (let n1 = 0; n1 <= max1; n1++) {
      for (const nq of ALLOWED_QUARTS) {
        const totalGallons = n5 * SIZE_5 + n1 * SIZE_1 + nq * SIZE_Q;
        if (totalGallons < gallonsNeeded) continue;

        const overage = totalGallons - gallonsNeeded;
        const totalContainers = n5 + n1 + nq;
        const candidate = { n5, n1, nq, totalGallons, overage, totalContainers };

        if (!best) {
          best = candidate;
          continue;
        }

        const better =
          candidate.overage < best.overage ||
          (candidate.overage === best.overage &&
            candidate.totalContainers < best.totalContainers) ||
          (candidate.overage === best.overage &&
            candidate.totalContainers === best.totalContainers &&
            candidate.n5 > best.n5) ||
          (candidate.overage === best.overage &&
            candidate.totalContainers === best.totalContainers &&
            candidate.n5 === best.n5 &&
            candidate.n1 > best.n1) ||
          (candidate.overage === best.overage &&
            candidate.totalContainers === best.totalContainers &&
            candidate.n5 === best.n5 &&
            candidate.n1 === best.n1 &&
            candidate.nq < best.nq);

        if (better) best = candidate;
      }
    }
  }

  if (!best) {
    const n1 = Math.ceil(gallonsNeeded);
    best = {
      n5: 0,
      n1,
      nq: 0,
      totalGallons: n1,
      overage: n1 - gallonsNeeded,
      totalContainers: n1,
    };
  }

  const sfCovered = best.totalGallons * coveragePerGallon;
  const woodLabel = woodType === "new" ? "New Wood" : "Old Wood";

  const lineItems = [];
  if (best.n5 > 0) {
    lineItems.push({ key: "5gal", quantity: best.n5, ...PRODUCTS["5gal"] });
  }
  if (best.n1 > 0) {
    lineItems.push({ key: "1gal", quantity: best.n1, ...PRODUCTS["1gal"] });
  }
  if (best.nq > 0) {
    lineItems.push({ key: "quart", quantity: best.nq, ...PRODUCTS.quart });
  }
  if (woodType === "old") {
    lineItems.push(
      { key: "cleaner", quantity: 1, ...PREP_PRODUCTS.cleaner },
      { key: "brightener", quantity: 1, ...PREP_PRODUCTS.brightener }
    );
  }

  return {
    squareFeet,
    woodType,
    woodLabel,
    coveragePerGallon,
    gallonsNeeded,
    sfCovered,
    sfOver: sfCovered - squareFeet,
    ...best,
    lineItems,
    fmt,
  };
}

function productIdForTone(baseId, toneId) {
  return toneId ? `${baseId}-${toneId}` : baseId;
}

function productNameForTone(name, toneLabel) {
  return toneLabel ? `${name} — ${toneLabel}` : name;
}

function resolveVariantId(item, toneId) {
  if (!item.requiresTone) {
    return item.variantId || null;
  }
  const sizeKey = item.sizeKey || item.key;
  const entry = CATALOG.stain?.variants?.[sizeKey]?.[toneId];
  return entry?.variantId || null;
}

function parseCalculatorParams(searchParams) {
  const sqft = parseFloat(searchParams.get("sqft"));
  const wood = searchParams.get("wood");
  if (!sqft || sqft <= 0 || (wood !== "new" && wood !== "old")) {
    return null;
  }
  return calculateOrder(sqft, wood);
}

window.SunFrogCalculator = {
  TONES,
  CATALOG,
  calculateOrder,
  productIdForTone,
  productNameForTone,
  resolveVariantId,
  parseCalculatorParams,
};
